import { ActivityIndicator, KeyboardAvoidingView, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import React, { useRef, useState } from 'react'
import { useFormsStore } from '../../../stores/onboarding'
import Toast from 'react-native-toast-message'
import { colorPalette, globalStyles } from '../../../static/styles/global'
import CustomButton from '../../shared/button/Button'
import moment from 'moment'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import { Ionicons } from '@expo/vector-icons'
import Card from '../../shared/card/Card'
import Canvas from '../../canvas'

const KarnsInformationOnline = ({ navigation, route }) => {
  const {
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
    values,
    completeOnline
  } = route.params

  const canvasRef = useRef(null)
  const [hasDrawn, setHasDrawn] = useState(false);
  const [hasDrawn2, setHasDrawn2] = useState(false);
  const [signatureDataURL, setSignatureDataURL] = useState('')
  const [signatureDataURL2, setSignatureDataURL2] = useState('')
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()
  const { loading, postKarnsOnline } = useFormsStore()

  const handlesubmit = async () => {
    const response: any = await postKarnsOnline(data)
    if (response?.success === true) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }


  const data = {
    essUserKey: initializestore?.initializeData?.userkey,
    entityId: personalstore.personalData?.entityId,
    EssObKey: essUserOnBoardingKey,
    essUserOnBoardingFormKey: essUserOnBoardingFormKey,
    completeOnline: true,
    name: personalstore?.personalData?.firstName + " " + personalstore?.personalData?.lastName,
    sign1: signatureDataURL,
    sign2: signatureDataURL2
  }


  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      style={{ flex: 1 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <TouchableOpacity
            onPress={() => navigation.navigate('OnboardingForms')}
            style={[
              globalStyles.hDirection,
              globalStyles.vCenterItems,
              globalStyles.flexOne
            ]}
          >
            <View style={[globalStyles.relativePosition, globalStyles.ln6]}>
              <Ionicons
                name="chevron-back"
                size={24}
                color={colorPalette.white}
              />
            </View>
            <Text style={[globalStyles.text, globalStyles.whiteTextColor]}>
              {'Forms '}
            </Text>
          </TouchableOpacity>
        </View>
        <View style={[globalStyles.vCenterItems]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs30,
              globalStyles.whiteTextColor,
              globalStyles.textCenter
            ]}
          >
            Karns Foods Uniform and Handbook
          </Text>
        </View>
      </View>
      <ScrollView>
        <Card >
          <p><strong >Print Name:</strong>
            <span style={{ borderBottom: '1px solid', }}>{personalstore?.personalData?.firstName} {personalstore?.personalData?.middleInitial} {personalstore?.personalData?.lastName}</span></p>
          <div style={{ fontFamily: 'Arial, sans-serif', fontSize: "11px" }}>
            <h1 style={{ textAlign: "center" }}>Karns Foods Employee Uniform Issuance and Authorization</h1>
            <p>
              As a Karns Food employee, I understand that I will be given uniform pieces to be utilized while employed at Karns.
            </p>
            <p>
              I accept responsibility for the issued uniform pieces and will, upon termination of my employment, return the same in an acceptable condition (normal wear considered) or, where applicable, pay the replacement cost for non-return and/or unacceptable condition. If necessary, a payroll deduction for the replacement cost is authorized.
            </p>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',

              }}
            >
              <tbody>
                <tr>
                  <td style={{ width: '60%', fontSize: '11px' }}>
                    <Canvas setSignatureDataURL={setSignatureDataURL} setHasDrawn={setHasDrawn} hasDrawn={hasDrawn} />
                    <br />
                    Employee's Signature
                  </td>
                  <td>
                    Date: <b>{moment().format('MM/DD/YYYY')}</b>
                  </td>
                </tr>
              </tbody>
            </table>

            <h2 style={{ textAlign: "center", }}>Karns Foods Employee Handbook</h2>

            <p >
              The Karns Foods employee manual is available online via Axonify at{' '}
              <a href="https://karnsfoods.axonify.com">karnsfoods.axonify.com</a> or on the Axonify mobile app.
              You will receive an invitation to join Axonify upon completion of your new hire setup.
            </p>
            <p>
              If you do not have access to the internet or would prefer a paper copy, please ask your manager or Human Resources at 717-766-6477 ext 3, for a copy.
            </p>
            <p>
              I acknowledge that I will review the Karns Foods Employee Handbook. I agree to read it thoroughly, including the statements in the forward describing the purpose and effect of the manual. I understand that it is my responsibility to read and comprehend the policies, standards, rules, and benefits outlined in the manual. I agree that if there is any policy or statement(s) that I do not understand, I will seek clarification from the Human Resources Department. I understand that Karns Foods is an “at will” employer and, as such, employment is not for a fixed term or definite period and may be terminated at the will of either party with or without cause and without prior notice. No supervisor or other representative of the company (except the President) has the authority to enter into any agreement for employment for any specified period of time or to make agreement contrary to the above.
            </p>
            <p>
              I understand that this manual states Karns Foods’ policies and practices in effect on the date of publication. I understand that nothing contained in the manual may be construed as creating a promise of future benefits or a binding contract with Karns Foods for benefits or for any other purpose. I also understand that these policies and procedures are continually evaluated, and Karns reserves the right to amend, change, or cancel this document at its discretion. Employees will be notified of changes and an up-to-date copy will be available.
            </p>
            <p>
              I understand that it is my responsibility to remain up-to-date on all current policies published to the Crew app or posted in the store.
            </p>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',


              }}
            >
              <tbody>
                <tr>
                  <td style={{ width: '60%', fontSize: '11px' }}>
                    <Canvas setSignatureDataURL={setSignatureDataURL2} setHasDrawn={setHasDrawn2} hasDrawn={hasDrawn2} />
                    <br />
                    Employee's Signature
                  </td>
                  <td>
                    Date: <b>{moment().format('MM/DD/YYYY')}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </Card>
        {loading ? <ActivityIndicator /> :
          <View
            style={{
              marginTop: 10,
              marginBottom: 25,
              flexDirection: 'row',
              justifyContent: 'space-between'
            }}
          >
            <CustomButton
              text={'Previous'}
              color={'warn'}
              onPress={() =>
                navigation.navigate('OnboardingForms', {
                  essUserOnBoardingFormKey,
                  essUserOnBoardingKey
                })
              }
            />
            <CustomButton
              isDisabled={!signatureDataURL || !signatureDataURL2 || !hasDrawn || !hasDrawn2}
              text={'Submit'}
              onPress={handlesubmit}
            />
          </View>}
      </ScrollView>

    </KeyboardAvoidingView>
  )
}

export default KarnsInformationOnline

const styles = StyleSheet.create({
  canvas: {
    backgroundColor: 'white',
    maxHeight: 55,
    width: '50%',
    marginLeft: 10
  }
})